import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FooterComponen from '../../components/footer';

const API_URL =
  'https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/mensualidadNatural';

const mensualidadStyles = `
  .mensualidad-row {
    max-width: 1350px;
    margin: 0 auto;
    padding: 0;
    align-items: stretch;
  }

  .mensualidad-img-col {
    display: flex;
  }

  .mensualidad-section {
    padding-top: 0px;
    padding-bottom: 35px;
  }

  .mensualidad-img-wrapper {
    width: 100%;
    height: 100%;
  }

  .mensualidad-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 24px;
    display: block;
  }

  .mensualidad-form-col {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mensualidad-form-inner {
    width: 100%;
    max-width: 420px;
  }

  .mensualidad-form-inner .mb-3,
  .mensualidad-form-inner .mb-2 {
    margin-bottom: 0.6rem !important;
  }

  .mensualidad-title {
    color: #8DC63F;
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 4px;
  }

  .mensualidad-subtitle {
    color: #8F8F8F;
    font-size: 12px;
    margin-bottom: 14px;
  }

  .mensualidad-form-inner .form-label {
    font-size: 13px;
  }

  .mensualidad-form-inner .form-control {
    font-size: 13px;
    padding: 0.35rem 0.75rem;
    height: 34px;
  }

  .mensualidad-form-inner .form-check-label {
    font-size: 12px;
  }

  .mensualidad-checkbox a {
    font-size: 12px;
    text-decoration: underline;
  }

  .mensualidad-submit {
    background-color: #8DC63F;
    border-color: #8DC63F;
    padding: 0.5rem 2.2rem;
    border-radius: 999px;
    font-weight: 600;
    min-width: 140px;
    font-size: 13px;
  }

  .mensualidad-submit:hover {
    background-color: #7CB238;
    border-color: #7CB238;
  }

  @media (max-width: 992px) {
    .mensualidad-row {
      margin: 10px 0;
      padding: 0;
      display: block;
    }

    .mensualidad-form-col {
      padding-left: 0;
      margin-top: 10px;
    }

    .mensualidad-form-inner {
      max-width: 100%;
    }

    .mensualidad-img-wrapper {
      height: auto;
    }

    .mensualidad-img {
      height: auto;
    }
  }
`;

const MensualidadNatural = () => {
  const [formData, setFormData] = useState({
    cedula: '',
    nombre: '',
    correo: '',
    celular: '',
    tipoVehiculo: 'CARRO',
    placa: '',
    aceptaPoliticaTratamiento: false,
    aceptaTerminosCondiciones: false,
  });

  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [tipoMensaje, setTipoMensaje] = useState(null);
  const [placaError, setPlacaError] = useState('');

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    if (name === 'tipoVehiculo') {
      setFormData((prev) => ({
        ...prev,
        tipoVehiculo: value,
        placa: value === 'BICICLETA' ? '' : prev.placa,
      }));
      setPlacaError('');
      return;
    }

    if (name === 'cedula') {
      const limpio = value.replace(/\D/g, '').slice(0, 11);
      setFormData((prev) => ({ ...prev, cedula: limpio }));
      return;
    }

    if (name === 'nombre') {
      const limpio = value
        .replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s]/g, '')
        .slice(0, 35);
      setFormData((prev) => ({ ...prev, nombre: limpio }));
      return;
    }

    if (name === 'correo') {
      setFormData((prev) => ({ ...prev, correo: value.slice(0, 40) }));
      return;
    }

    if (name === 'celular') {
      const limpio = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prev) => ({ ...prev, celular: limpio }));
      return;
    }

    if (name === 'placa') {
      const limpio = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 6);
      setFormData((prev) => ({ ...prev, placa: limpio }));
      setPlacaError('');
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

const validarPlaca = () => {
  const { tipoVehiculo, placa } = formData;

  if (tipoVehiculo === 'BICICLETA') return true;

  if (!placa) {
    setPlacaError('La placa es obligatoria.');
    return false;
  }

  const placaUpper = placa.toUpperCase();
  const regexCarro = /^[A-Z]{3}\d{3}$/;
  const regexMoto = /^[A-Z]{3}\d{2}[A-Z]?$/; // ABC12 o ABC12E

  if (tipoVehiculo === 'CARRO' && !regexCarro.test(placaUpper)) {
    setPlacaError('Formato de placa de carro inválido. Ej: ABC123');
    return false;
  }

  if (tipoVehiculo === 'MOTO' && !regexMoto.test(placaUpper)) {
    setPlacaError('Formato de placa de moto inválido. Ej: ABC12 o ABC12E');
    return false;
  }

  return true;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPlacaError('');
    setMensaje(null);

    const {
      cedula,
      nombre,
      correo,
      celular,
      tipoVehiculo,
      placa,
      aceptaPoliticaTratamiento,
      aceptaTerminosCondiciones,
    } = formData;

    if (!cedula || !nombre || !correo || !celular) {
      setTipoMensaje('error');
      setMensaje('Completa todos los campos.');
      return;
    }

      if (cedula.length < 5) {
    setTipoMensaje('error');
    setMensaje('La cédula debe tener mínimo 5 dígitos.');
    return;
  }

  if (nombre.trim().length < 6) {
    setTipoMensaje('error');
    setMensaje('El nombre debe tener mínimo 6 caracteres.');
    return;
  }

  if (celular.length !== 10) {
    setTipoMensaje('error');
    setMensaje('El celular debe tener exactamente 10 dígitos.');
    return;
  }


    if (!aceptaPoliticaTratamiento || !aceptaTerminosCondiciones) {
      setTipoMensaje('error');
      setMensaje(
        'Debes aceptar los Términos y Condiciones y la Política de Tratamiento de Datos.'
      );
      return;
    }

    if (!validarPlaca()) {
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cedula: cedula.trim(),
          nombre: nombre.trim(),
          correo: correo.trim(),
          celular: celular.trim(),
          tipoVehiculo,
          placa: tipoVehiculo === 'BICICLETA' ? '' : placa.toUpperCase(),
          aceptaPoliticaTratamiento,
          aceptaTerminosCondiciones,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && data.status) {
        setTipoMensaje('ok');
        setMensaje(data.message || 'Datos registrados correctamente.');
        setTimeout(() => {
          window.location.href = 'https://www.parking.net.co/#/';
        }, 3000);
      } else {
        setTipoMensaje('error');
        setMensaje(
          data.message ||
            'No fue posible registrar la información. Intenta nuevamente.'
        );
      }
    } catch {
      setTipoMensaje('error');
      setMensaje('Error al conectar con el servidor.');
    }

    setLoading(false);
  };

  const placaDisabled = formData.tipoVehiculo === 'BICICLETA';

  return (
    <>
      <style>{mensualidadStyles}</style>

      <div className="mensualidad-section">
        <Container fluid>
          <Row className="mensualidad-row">
            <Col xs={12} sm={12} md={7} lg={7} xl={7} className="mensualidad-img-col">
              <div className="mensualidad-img-wrapper">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/parkingpaginawebproduccion.appspot.com/o/Imagenes%2Fmensualidad%20natural.png?alt=media&token=c1cb0820-031e-458e-b2bd-f8900cceedd4"
                  className="mensualidad-img"
                  alt="Mensualidades - Tu cupo fijo, mes a mes"
                />
              </div>
            </Col>

            <Col xs={12} sm={12} md={5} lg={5} xl={5} className="be-registro mensualidad-form-col">
              <div className="mensualidad-form-inner">
                <h3 className="mensualidad-title">Datos de tu Mensualidad Natural</h3>
                <p className="mensualidad-subtitle">
                  Queremos mantener tu información actualizada y asegurarte una mejor gestión de tu mensualidad.
                </p>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Cédula</Form.Label>
                    <Form.Control
                      type="text"
                      name="cedula"
                      value={formData.cedula}
                      onChange={handleChange}
                      maxLength={11}
                      inputMode="numeric"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Nombre Completo</Form.Label>
                    <Form.Control
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      maxLength={35}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Correo Electrónico</Form.Label>
                    <Form.Control
                      type="email"
                      name="correo"
                      value={formData.correo}
                      onChange={handleChange}
                      maxLength={40}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Celular</Form.Label>
                    <Form.Control
                      type="tel"
                      name="celular"
                      value={formData.celular}
                      onChange={handleChange}
                      maxLength={10}
                      inputMode="numeric"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Tipo de vehículo</Form.Label>
                    <div>
                      <Form.Check
                        inline type="radio" label="Carro" name="tipoVehiculo" value="CARRO"
                        checked={formData.tipoVehiculo === 'CARRO'} onChange={handleChange}
                      />
                      <Form.Check
                        inline type="radio" label="Moto" name="tipoVehiculo" value="MOTO"
                        checked={formData.tipoVehiculo === 'MOTO'} onChange={handleChange}
                      />
                      <Form.Check
                        inline type="radio" label="Bicicleta" name="tipoVehiculo" value="BICICLETA"
                        checked={formData.tipoVehiculo === 'BICICLETA'} onChange={handleChange}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      name="placa"
                      value={formData.placa}
                      onChange={handleChange}
                      disabled={placaDisabled}
                      maxLength={6}
                      placeholder={placaDisabled ? 'No aplica para bicicleta' : 'Placa'}
                    />
                    {placaError && (
                      <Form.Text className="text-danger">{placaError}</Form.Text>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-2 mensualidad-checkbox">
                    <Form.Check
                      type="checkbox"
                      name="aceptaTerminosCondiciones"
                      checked={formData.aceptaTerminosCondiciones}
                      onChange={handleChange}
                      label={
                        <>
                          Acepto{' '}
                          <a href="/#/TYC-Mensualidad-Natural" target="_blank" rel="noopener noreferrer">
                            términos y condiciones del producto mensualidad natural
                          </a>
                        </>
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3 mensualidad-checkbox">
                    <Form.Check
                      type="checkbox"
                      name="aceptaPoliticaTratamiento"
                      checked={formData.aceptaPoliticaTratamiento}
                      onChange={handleChange}
                      label={
                        <>
                          Acepto{' '}
                          <a href="/#/Politica-TratamientoDatos" target="_blank" rel="noopener noreferrer">
                            políticas de tratamiento de datos
                          </a>
                        </>
                      }
                    />
                  </Form.Group>

                  {mensaje && (
                    <div className={`alert alert-${tipoMensaje === 'ok' ? 'success' : 'danger'}`}>
                      {mensaje}
                    </div>
                  )}

                  <Button type="submit" className="mensualidad-submit" disabled={loading}>
                    {loading ? 'Enviando...' : 'Enviar'}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <FooterComponen />
    </>
  );
};

export default MensualidadNatural;
